<template>
  <v-container fluid >
    <v-row justify="start">
      <v-col cols="12" md="3" lg="3" sm="12">
        <v-select
          v-model="cluster"
          :items="cluster_items"
          label="Места концентрации"
          dense
        ></v-select>
      </v-col>
      <v-col cols="12" md="2" lg="2" sm="12">
        <v-select
          v-model="location"
          :items="location_items"
          label="Местоположение"
          multiple
          dense
        ></v-select>
      </v-col>
      <v-col cols="12" md="2" lg="2" sm="12" class="mt-n4">
        <v-select v-model="year" :items="years" label="Год"></v-select>
      </v-col>
      <v-col cols="12" md="1" lg="2" sm="3" xs="2" class="mt-n1">
        <v-btn @click="filterDTP">Применить</v-btn>
      </v-col>
      <v-col cols="12" md="2" lg="2" sm="3" xs="2" class="mt-n1">
        <v-btn @click="dialog = true" color="primary">Доп. фильтры</v-btn>
      </v-col>
      <v-col cols="12" md="1" lg="1" sm="3" xs="2" class="mt-n1">
        <v-btn color="error" @click="resetFilter">Сбросить</v-btn>
      </v-col>
    </v-row>

    <!-- Окно с фильтрами -->
    <v-row justify="center" >
      <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Дополнительные фильтры</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark text @click="reset_dop_filtr"> Сбросить </v-btn>
            </v-toolbar-items>
            <v-toolbar-items>
              <v-btn dark text @click="dialog = false"> Применить </v-btn>
            </v-toolbar-items>
          </v-toolbar>

          <v-row align="center" justify="start" class="pl-2 pr-2">
            <v-col cols="12" lg="6" md="6">
              <v-card class="pr-8 pl-8 pt-2">
                <v-select
                  v-model="type_dtp"
                  :items="type_dtp_items"
                  label="Вид дтп"
                  multiple
                ></v-select>

                <v-select
                  v-model="lighting"
                  :items="lighting_items"
                  label="Освещение"
                  multiple
                ></v-select>

                <v-select
                  v-model="dividing_line_type"
                  :items="dividing_line_type_items"
                  label="Вид разделительной полосы"
                  multiple
                ></v-select>
              </v-card>
            </v-col>

            <v-col cols="12" lg="6" md="6">
              <v-card class="pr-8 pl-8 pt-2">
                <v-select
                  v-model="road_condition"
                  :items="road_condition_items"
                  label="Состояние проезжей части"
                  multiple
                ></v-select>

                <v-select
                  v-model="weather_1"
                  :items="weather_1_items"
                  label="Состояние погоды"
                  multiple
                ></v-select>

                <v-select
                  v-model="type_dtp"
                  :items="coating_type_items"
                  label="Вид покрытия"
                  multiple
                ></v-select>
              </v-card>
            </v-col>
          </v-row>

          <v-row align="center" justify="start" class="pl-2 pr-2">
            <v-col cols="12">
              <v-card class="pr-8 pl-8 pt-2">
                <v-select
                  v-model="ndu_1"
                  :items="ndu_1_items"
                  label="НДУ"
                  multiple
                ></v-select>

                <v-select
                  v-model="uds_inplace_1"
                  :items="uds_inplace_1_items"
                  label="УДС на месте"
                  multiple
                ></v-select>

                <v-select
                  v-model="uds_near_1"
                  :items="uds_near_1_items"
                  label="УДС вблизи"
                  multiple
                ></v-select>
              </v-card>
            </v-col>
          </v-row>

          <v-row align="center" justify="start" class="pl-2 pr-2">
            <v-col cols="12" md="6" lg="6">
              <v-card class="pr-8 pl-8 pt-2">
                <v-card-title>Время:</v-card-title>
                <v-divider></v-divider>
                <v-select
                  v-model="time_after"
                  :items="time_items"
                  label="Время(начало)"
                >
                </v-select>
                <v-select
                  v-model="time_before"
                  :items="time_items"
                  label="Время(конец)"
                >
                </v-select>
              </v-card>
            </v-col>
            <v-col cols="12" md="6" lg="6">
              <v-card class="pr-8 pl-8 pt-2">
                <v-card-title>Дата:</v-card-title>
                <v-divider></v-divider>
                <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="date_after"
                      label="Дата(начало)"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="date_after"
                    @input="menu = false"
                  ></v-date-picker>
                </v-menu>

                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="date_before"
                      label="Дата(конец)"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="date_before"
                    @input="menu2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-card>
            </v-col>
          </v-row>

          <v-row align="center" justify="start" class="pl-2 pr-2">
            <v-col cols="12" md="6" lg="6">
              <v-card class="pr-8 pl-8 pt-2">
                <v-select
                  v-model="loss"
                  :items="loss_items"
                  label="Погибшие"
                ></v-select>

                <v-select
                  v-model="loss_child"
                  :items="loss_items"
                  label="Погибшие дети"
                ></v-select>

                <v-select
                  v-model="injured"
                  :items="injured_items"
                  label="Раненые"
                ></v-select>

                <v-select
                  v-model="injured_child"
                  :items="injured_items"
                  label="Раненые дети"
                ></v-select>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      cluster_items: [
        "Входящие в места концентрации",
        "Не входящие в места концентрации",
      ],
      location_items: ["Город", "Загород", "Другое"],
      time_items: [
        "0:00",
        "1:00",
        "2:00",
        "3:00",
        "4:00",
        "5:00",
        "6:00",
        "7:00",
        "8:00",
        "9:00",
        "10:00",
        "11:00",
        "12:00",
        "13:00",
        "14:00",
        "15:00",
        "16:00",
        "17:00",
        "18:00",
        "19:00",
        "21:00",
        "22:00",
        "23:00",
      ],
      type_dtp_items: [
        "Столкновение",
        "Наезд на препятствие",
        "Наезд на велосипедиста",
        "Наезд на пешехода",
        "Наезд на стоящее ТС",
        "Наезд на животное",
        "Опрокидывание",
        "Падение пассажира",
        "Съезд с дороги",
        "Отбрасывание предмета(отсоединение колеса)",
        "Возгорание вследствие технической неисправности движущегося или остановившегося ТС, участвующего в дорожном движении",
        "Наезд на лицо, не являющееся участником дорожного движения(иного участника ДТП), осуществляющее производство работ",
        "Иной вид ДТП"
      ],
      lighting_items: [
        "В темное время суток, освещение включено",
        "В темное время суток, освещение отсутствует",
        "В темное время суток, освещение не включено",
        "Светлое время суток",
        "Сумерки"
      ],
      weather_1_items: [
        "Дождь",
        "Метель",
        "Пасмурно",
        "Снегопад",
        "Туман",
        "Ясно"
      ],
      road_condition_items: [
        "Обработанное противогололедными материалами",
        "Со снежным накатом",
        "Загрязненное",
        "Заснеженное",
        "Гололедица",
        "Пыльное",
        "Мокрое",
        "Сухое",
      ],
      coating_type_items: [
        "Асфальтобетонное с поверхностной обработкой",
        "Асфальтобетонное",
        "Щебеночное (гравийное)",
        "Грунтовое",
        "Металлическое",
        "Иной вид покрытия"
      ],
      dividing_line_type_items: [
        "Разделительная полоса с грунтовым покрытием",
        "Разделительная полоса, выделенная разметкой",
        "Разделительная полоса с барьером в виде металлической конструкции",
        "Разделительная полоса с барьером в виде железо-бетонной конструкции",
        "Разделительная полоса отсутствует",
        "Иной вид разделительной полосы"
      ],
      ndu_1_items: [
        "Отсутствие недостатков транспортно-эксплуатационного состояния проезжей части",
        "Отсутствие, плохая различимость горизонтальной разметки проезжей части",
        "Отсутствие, дорожных знаков в необходимых местах",
        "Отсутствие пешеходных ограждений в необходимых местах",
        "Отсутствие освещения",
        "Отсутствие направляющих устройств и световозвращающих элементов на них",
        "Отсутствие тротуаров (пешеходных дорожек)",
        "Отсутствие временных ТСОД в местах производства работ",
        "Отсутствие элементов обустройства остановочного пункта общественного пассажирского транспорта",
        "Отсутствие дорожных ограждений в необходимых местах",
        "Неправильное применение, плохая видимость дорожных знаков",
        "Несоответствие дорожных ограждений предъявляемым требованиям",
        "Неисправное освещение",
        "Недостатки зимнего содержания",
        "Неисправность светофора",
        "Неудовлетворительное состояние обочин",
        "Дефекты покрытия",
        "Ограничение видимости",
        "Недостаточное освещение",
        "Не установлено"
      ],
      uds_inplace_1_items: [
        "Регулируемый пешеходный переход",
        "Нерегулируемый пешеходный переход",
        "Нерегулируемый пешеходный переход, расположенный на участке улицы или дороги, проходящей вдоль территории школы или иной детской организации",
        "Нерегулируемый перекрёсток неравнозначных улиц (дорог)",
        "Нерегулируемый перекрёсток равнозначных улиц (дорог)",
        "Перегон (нет объектов на месте ДТП)",
        "Внутридворовая территория",
        "Регулируемый перекресток",
        "Автостоянка (отделенная от проезжей части)",
        "Автостоянка (не отделенная от проезжей части)",
        "Нерегулируемое пересечение с круговым движением",
        "Выезд с прилегающей территории",
        "Остановка общественного транспорта",
        "Тротуар, пешеходная дорожка",
        "Мост, эстакада, путепровод",
        "Подход к мосту, эстакаде, путепроводу",
        "Остановка трамвая",
        "Тоннель",
        "АЗС",
        "Иное место",
      ],
      uds_near_1_items: [
        "Автовокзал (автостанция)",
        "Автостоянка (отделенная от проезжей части)",
        "Административные здания",
        "АЗС",
        "Аэропорт, ж/д вокзал (ж/д станция), речной или морской порт(пристань)",
        "Жилые дома индивидуальной застройки",
        "Зоны отдыха",
        "Иная образовательная организация",
        "Иной объект",
        "Кладбище",
        "Крупный торговый объект (являющийся объектом массового тяготения пешеходов и(или) транспорта)",
        "Медицинские (лечебные) организации",
        "Многоквартирные жилые дома",
        "Мост",
        "Надземный пешеходный переход",
        "Нерегулируемое пересечение с круговым движением",
        "Нерегулируемый перекрёсток",
        "Нерегулируемый пешеходный переход",
        "Объект (здание, сооружение) религиозного культа",
        "Объект строительства",
        "Объект торговли, общественного питания на автодороге вне НП",
        "Одиночный торговый объект, являющийся местом притяжения транспорта и(или) пешеходов",
        "Остановка общественного транспорта",
        "Остановка трамвая",
        "Отсутствие в непосредственной близости объектов УДС и объектов притяжения",
        "Подземный пешеходный переход",
        "Производственное предприятие",
        "Регулируемый перекрёсток",
        "Регулируемый пешеходный переход",
        "Спортивные и развлекательные объекты",
        "Школа либо иная детская (в т.ч. дошкольная) организация",
        "Эстакада, путепровод",
      ],
      loss_items: [
        {text: "Есть", value: true},
        {text: "Нет", value: false}
      ],
      injured_items: [
        {text: "Есть", value: true},
        {text: "Нет", value: false}
      ],
      years: [],
      menu: false,
      menu2: false,
      dialog: false,
      location: [],
      cluster: "",
      year: "",
      type_dtp: [],
      lighting: [],
      weather_1: [],
      road_condition: [],
      coating_type: [],
      dividing_line_type: [],
      ndu_1: [],
      uds_inplace_1: [],
      uds_near_1: [],
      time_after: "",
      time_before: "",
      date_after: "",
      date_before: "",
      loss: null,
      loss_child: null,
      injured: null,
      injured_child: null

    };
  },
  methods: {
    ...mapActions(["GET_MARKERS"]),
    filterDTP() {
      this.$store.dispatch("GET_MARKERS", {
        location: this.location,
        year: this.year,
        type_dtp: this.type_dtp,
        lighting: this.lighting,
        weather_1: this.weather_1,
        road_condition: this.road_condition,
        coating_type: this.coating_type,
        dividing_line_type: this.dividing_line_type,
        ndu_1: this.ndu_1,
        uds_inplace_1: this.uds_inplace_1,
        uds_near_1: this.uds_near_1,
        time_after: this.time_after,
        time_before: this.time_before,
        date_after: this.date_after,
        date_before: this.date_before,
        loss: this.loss,
        loss_child: this.loss_child,
        injured: this.injured,
        injured_child: this.injured_child
      });
    },
    resetFilter() {
      this.location = "Все";
      this.cluster = "Все";
      this.year = null;
    },
    reset_dop_filtr() {
      this.type_dtp = [];
      this.lighting = [];
      this.weather_1 = [];
      this.road_condition = [];
      this.coating_type = [];
      this.dividing_line_type = [];
      this.ndu_1 = [];
      this.uds_inplace_1 = [];
      this.uds_near_1 = [];
      this.time_after = "";
      this.time_before = "";
      this.date_after = "";
      this.date_before = "";
      this.loss = null;
      this.loss_child = null;
      this.injured = null;
      this.injured_child = null;
    }
  },
  computed: {
    dateRangeText() {
      return this.dates.join(" ~ ");
    },
  },
  mounted() {
    let data = new Date();
    for (let i = data.getFullYear(); i >= 2016; i--) {
      this.years.push(i);
    }
  },
};
</script>

<style>
</style>
